
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface LocationStateHandlerProps {
  setTableData: (data: any) => void;
  setShowTable: (show: boolean) => void;
  setSelectedCountry: (country: string | null) => void;
  setSelectedLeague: (league: string | null) => void;
  setSelectedYear: (year: string | null) => void;
}

interface LeagueState {
  type: string;
  data: any;
  selectedCountry: string;
  selectedLeague: string;
  selectedYear: string;
}

const LocationStateHandler: React.FC<LocationStateHandlerProps> = ({
  setTableData,
  setShowTable,
  setSelectedCountry,
  setSelectedLeague,
  setSelectedYear,
}) => {
  const location = useLocation();

  useEffect(() => {
    const state = location.state as LeagueState;
    if (state?.type === 'leagueTable' && state?.data) {
      setTableData(state.data);
      setShowTable(true);
      setSelectedCountry(state.selectedCountry);
      setSelectedLeague(state.selectedLeague);
      setSelectedYear(state.selectedYear);
      window.history.replaceState({}, '');
    }
  }, [location.state, setTableData, setShowTable, setSelectedCountry, setSelectedLeague, setSelectedYear]);

  return null; // This is a utility component with no UI
};

export default LocationStateHandler;
